<section
  class="brand-info-container"
  [ngStyle]="{'background-color': storyBrandContent?.backgroundColor?.color}"
  [appStoryblokEditable]="storyBrandContent?._editable"
  (window:resize)="onResize()">
  <div>
    <h1>{{ brandInfo.name }}</h1>
    <section class="brand-info-container__info">
      <ng-container *ngIf="isMobileOrTablet; else desktopLayout">
        <p>
          <ng-container *ngTemplateOutlet="productCount"></ng-container>
        </p>
        <p>
          <ng-container *ngTemplateOutlet="categoryCount"></ng-container>
        </p>
      </ng-container>
    </section>
  </div>
  <img
    class="brand-info-container__logo"
    *ngIf="storyBrandContent?.logo?.filename"
    [src]="storyBrandContent?.logo?.filename + logoFitSize"
    [alt]="storyBrandContent?.logo?.alt">
</section>

<ng-template #desktopLayout>
  <p>
    <ng-container *ngTemplateOutlet="productCount"></ng-container>
    <ng-container *ngTemplateOutlet="categoryCount"></ng-container>
  </p>
</ng-template>

<ng-template #productCount>
  {{'PAGES.BRAND_PLP.PRODUCT_COUNT' | translate: {
    count: brandInfo?.productsCount
  } }}
</ng-template>

<ng-template #categoryCount>
  {{'PAGES.BRAND_PLP.CATEGORY_COUNT' | translate: {
    count: categories.length
  } }}
</ng-template>
